import { render, staticRenderFns } from "./FilterOrganizer.vue?vue&type=template&id=976e9250"
import script from "./FilterOrganizer.vue?vue&type=script&lang=js"
export * from "./FilterOrganizer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports